import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {ClickOutsideModule} from '../../../directives/clickOutside/clickOutside.module';
import {WorkgroupModalComponent} from './workgroup-modal.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ClickOutsideModule
  ],
  providers: [
  ],
  declarations: [
    WorkgroupModalComponent
  ],
  exports: [
    WorkgroupModalComponent
  ]
})
export class WorkgroupModalModule {
}
